import React from "react";
import Lucide from "src/base-components/Lucide";

interface MessageActionMenuProps {
  isOpen: boolean;
  position: { x: number; y: number };
  message: any;
  handleStartEdit: (message: any) => void;
  handleShowDeleteModal: (message: any) => void;
  closeActionMenu: () => void;
}

const MessageActionMenu: React.FC<MessageActionMenuProps> = ({
  isOpen,
  position,
  message,
  handleStartEdit,
  handleShowDeleteModal,
  closeActionMenu,
}) => {
  if (!isOpen || !message) return null;

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={closeActionMenu} />
      <div
        className="fixed z-50 bg-white rounded-lg shadow-xl border py-1 min-w-[60px]"
        style={{
          top: position.y,
          left: position.x,
          transform: "translate(-50%, -100%)",
        }}
      >
        <button
          onClick={() => handleStartEdit(message)}
          className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100 flex items-center gap-2"
        >
          <Lucide icon="Pencil" className="w-4 h-4" />
          Edit
        </button>
        {/* <button
          onClick={() => handleShowDeleteModal(message)}
          className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100 flex items-center gap-2 text-red-600"
        >
          <Lucide icon="Trash2" className="w-4 h-4" />
          Delete
        </button> */}
      </div>
    </>
  );
};

export default MessageActionMenu;
